import React, { useEffect } from 'react'
import DownloadContent from '../components/Download/DownloadContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../redux/language/selector'
const Download = () => {

   const { t } = useTranslation()
 
   const language = useSelector(selectLanguage)
 
   useEffect(() => {
     document.title = t('download-page.title')
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [language])

  return (
    <>
        <DownloadContent/>
    </>
  )
}

export default Download